import {ProgramInterface} from '@interfaces/program.interface';
import {Schedule} from '@models/schedule';
import {Class} from '@models/class';
import {User} from '@models/user';
import {Subscription} from '@models/subscription';
import {Curriculum} from '@models/curriculum';

export class Program implements ProgramInterface {
  id?: number;
  program_id?: number;
  program_name: string;
  repeat: string;
  program_description: string;
  private: boolean;
  lastAction?: string;
  schedule: Schedule[] ;
  /**
   *  replaced_schedule will create, when repeated program add to class unique schedule.
   */
  replaced_schedule: Schedule[] ;
  default_teacher: User ;
  classes: Class[] ;
  teacher_id?: number;
  teachers?: User[];
  subscriptions?: Subscription[];
  curriculum?: Curriculum[];
  fromApischedule?: any;
  start_curriculum?: string;
  end_curriculum?: string;
  preview?: boolean;
  trial?: boolean;
  students_count?: boolean;
}
